class WidgetModel {
  id = null
  name = null
  patientId = null
  monitorId = null
  monitor = null
  params = {}
  /**
   * true if widget is loaded inside flex view. Used to disable some widget features
   * @type {boolean}
   */
  flexView = false
  /**
   * if widget should be loaded in 'guest mode'(viewing shared) - currently disables remove, expand and set color options from widget settings
   * @type {boolean}
   */
  isGuest = false
  /**
   * @typedef {Object} Badge
   * @property {boolean} enabled
   * @property {string} title
   * @property {string} tooltipText
   * @property {('is-error'|'is-success'|'is-warning'|'is-info')} type
   */

  /**
   * @typedef {Object} WidgetSettings
   * @property {boolean} retrievePatientInfo - Whether or not to retrieve default patient's information (room status and basic patient information). Default is true
   * @property {string} borderColor - Color to apply on the border of card.
   * @property {boolean} isHistorical - Indicating if data for this widget is historical. Used by card component to draw badge
   * @property {boolean} isExpanded
   * @property {boolean} isCentralMonitoring
   * @property {Badge} badge
   * @default
   */

  /**
   * Settings for widgets used internally
   * @type {WidgetSettings}
   */
  settings = {
    retrievePatientInfo: true,
    borderColor: '',
    isHistorical: false,
    isExpanded: false,
    isPopup: false,
    isCentralMonitoring: false,
    badge: {
      enabled: false,
      title: null,
      tooltipText: null,
      type: 'is-error'
    }
  }

  static Types = Object.freeze({
    'static': 1,
    'chart': 2
  })

  /**
   * @param {string} name
   * @param {object} params
   * @param {WidgetSettings} settings
   */
  constructor(name, params = {}, settings = {}) {
    this.name = name
    this.params = params
    this.settings = Object.assign(this.settings, settings)
  }
}
export default WidgetModel
